import classNames from 'classnames';
import MainNavigationLargeDropdownContentSearch from '@/components/organisms/main-navigation/main-navigation-large/main-navigation-large-dropdown/main-navigation-large-dropdown-content-search/main-navigation-large-dropdown-content-search';
import MainNavigationLargeDropdownLinks from '@/components/organisms/main-navigation/main-navigation-large/main-navigation-large-dropdown/main-navigation-large-dropdown-links/main-navigation-large-dropdown-links';
import { MainNavigationMenuItem } from '../../main-navigation';
import styles from './main-navigation-large-dropdown.module.scss';

export interface MainNavigationLargeDropdownProps {
  /** The class name to apply */
  className?: string;
  /** Indicates whether the dropdown is open */
  isOpen?: boolean;
  /** The navigation item */
  item: MainNavigationMenuItem;
  /** An event that is triggered on click */
  onClick?: () => void;
  /** An event that is triggered on close */
  onClose?: () => void;
}

const MainNavigationLargeDropdown = ({
  className,
  isOpen = false,
  item,
  onClick,
  onClose,
}: MainNavigationLargeDropdownProps) => {
  const renderContent = () => {
    if (item.items && item.items.length > 0 && item.type !== 'search') {
      return (
        <MainNavigationLargeDropdownLinks
          card={item.campaignTeaser}
          headline={item.link.text}
          items={item.items}
          layout={item.layout}
          masonrySettings={item.masonrySettings}
          onClick={onClick}
        />
      );
    }

    if (item.type === 'search') {
      return (
        <MainNavigationLargeDropdownContentSearch
          isOpen={isOpen}
          link={item.link}
          onClose={onClose}
        />
      );
    }
  };

  return (
    <div
      className={classNames(styles.component, className, {
        [styles.isOpen]: isOpen,
        [styles.isSearch]: item.type === 'search',
      })}
    >
      {renderContent()}
    </div>
  );
};

MainNavigationLargeDropdown.displayName = 'MainNavigationLargeDropdown';

export default MainNavigationLargeDropdown;
